module.exports = __webpack_public_path__ + "img/header-background.eec20261.svg";